import { getOpenAxiosInstance } from './api';
import { addEnvQueryParam, getErrorResponse } from './helpers';
import { getClientTelemetryHeaders } from '../telemetry';

export const axiosOpenPostRequest = async <T1, T2>(
  url: string,
  data?: T1,
  clientAction?: string
): Promise<T2> => {
  const requestUrl = addEnvQueryParam(url);
  const clientTelemetryHeaders = await getClientTelemetryHeaders({
    clientAction,
    method: 'post',
    url: requestUrl,
  });

  return new Promise((resolve, reject) => {
    const openAxiosInstance = getOpenAxiosInstance();

    openAxiosInstance &&
      openAxiosInstance({
        method: 'post',
        url: requestUrl,
        data,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Ocp-Apim-Subscription-Key': '570d3c36af3e417d98f9fbde9738c290',
          ...clientTelemetryHeaders,
        },
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(getErrorResponse(error));
          // here we should not log an error as this is used by API calls for logging errors
        });
  });
};

export const axiosOpenPatchRequest = async <T1, T2>(
  url: string,
  data?: T1,
  clientAction?: string
): Promise<T2> => {
  const requestUrl = addEnvQueryParam(url);
  const clientTelemetryHeaders = await getClientTelemetryHeaders({
    clientAction,
    method: 'patch',
    url: requestUrl,
  });

  return new Promise((resolve, reject) => {
    const openAxiosInstance = getOpenAxiosInstance();

    openAxiosInstance &&
      openAxiosInstance({
        method: 'patch',
        url: requestUrl,
        data,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          // 'Ocp-Apim-Subscription-Key': '570d3c36af3e417d98f9fbde9738c290',
          ...clientTelemetryHeaders,
        },
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(getErrorResponse(error));
          // here we should not log an error as this is used by API calls for logging errors
        });
  });
};

